// ABOUTME: Right panel of the news article builder modal.
// ABOUTME: Handles audience selection (customers, relations) and per-fulfilment-company exclusions via InputDropdown.

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import Subheading from "../../../../theme/text/Subheading";
import Text from "../../../../theme/text/Text";
import { InputDropdown } from "../../../../theme/dropdowns/InputDropdown";
import { useGetCustomersQuery } from "../../../../../newapi/user/userSlice";

// "customers" covers fulfilment companies — customers that fulfil orders for their
// own relations. "webshops" covers customers that only fulfil their own orders.
const AUDIENCE_OPTIONS = [
    { id: "customers", name: "customers" },
    { id: "webshops", name: "webshops" },
    { id: "relations", name: "relations" },
];

const AudiencePanelView = ({
    audience,
    setAudience,
    excludedCustomerIds,
    setExcludedCustomerIds,
    excludedRelationCustomerIds,
    setExcludedRelationCustomerIds,
    colors,
    theme,
}) => {
    const { t } = useTranslation();

    // A selected audience reaches every fulfilment company (or all of their
    // relations); these lists leave single companies out of it.
    const showCustomerExclusion = audience.includes("customers");
    const showRelationExclusion = audience.includes("relations");

    const { data: customersData } = useGetCustomersQuery(undefined, {
        skip: !showCustomerExclusion && !showRelationExclusion,
    });
    const customers = customersData?.data?.customers ?? customersData?.customers ?? [];
    const fulfilmentOptions = customers.filter((c) => c.isFulfilment);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                p: 3,
                minWidth: 220,
            }}
        >
            <Subheading>{t("audience") || "Doelgroep"}</Subheading>
            <Box>
                <Text fontSize={13} sx={{ mb: 1 }}>
                    {t("visible_for") || "Zichtbaar voor"}
                </Text>
                <InputDropdown
                    displayName="name"
                    valueKey="id"
                    noSelection={t("choose")}
                    options={AUDIENCE_OPTIONS}
                    selected={audience}
                    multiple
                    useTranslation
                    onChange={(selected) => {
                        setAudience(selected);
                    }}
                    closeOnSelection={false}
                />
            </Box>
            {showCustomerExclusion && (
                <Box>
                    <Text fontSize={13} sx={{ mb: 1 }}>
                        {t("excluded_fulfilment_companies")}
                    </Text>
                    <InputDropdown
                        displayName="name"
                        valueKey="id"
                        noSelection={t("none")}
                        options={fulfilmentOptions}
                        selected={excludedCustomerIds}
                        multiple
                        onChange={(selected) => setExcludedCustomerIds(selected)}
                        closeOnSelection={false}
                        searchOptions={{ enabled: true, placeholder: t("search") }}
                    />
                </Box>
            )}
            {showRelationExclusion && (
                <Box>
                    <Text fontSize={13} sx={{ mb: 1 }}>
                        {t("excluded_relations_of_fulfilment_companies")}
                    </Text>
                    <InputDropdown
                        displayName="name"
                        valueKey="id"
                        noSelection={t("none")}
                        options={fulfilmentOptions}
                        selected={excludedRelationCustomerIds}
                        multiple
                        onChange={(selected) => setExcludedRelationCustomerIds(selected)}
                        closeOnSelection={false}
                        searchOptions={{ enabled: true, placeholder: t("search") }}
                    />
                </Box>
            )}
        </Box>
    );
};

export default AudiencePanelView;
